import React from 'react'

export default function VueIcon() {
   return (
      <svg
         width="64"
         height="55"
         viewBox="0 0 64 55"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <g clipPath="url(#clip0_2355_46681)">
            <path
               d="M51.1099 0H63.852L31.9968 54.9502L0.141602 0H24.5108L31.9968 12.7421L39.3235 0H51.1099Z"
               fill="#1F473E"
            />
            <path
               d="M0.141602 0L31.9968 54.9502L63.852 0H51.1099L31.9968 32.9701L12.7244 0H0.141602Z"
               fill="#1F473E"
            />
            <path
               d="M12.7246 0L31.997 33.1294L51.1101 0H39.3237L31.997 12.7421L24.511 0H12.7246Z"
               fill="#88998D"
            />
         </g>
         <defs>
            <clippath id="clip0_2355_46681">
               <rect
                  width="63.7164"
                  height="55"
                  fill="white"
                  transform="translate(0.141602)"
               />
            </clippath>
         </defs>
      </svg>
   )
}
